<!-- Toggle Button -->
<div
  class="offcanvas-toggle"
  [ngClass]="{
    open: isOpen,
    'position-left': position === 'left',
    'position-right': position === 'right',
    'size-sm': size === 'sm',
    'size-md': size === 'md',
    'size-lg': size === 'lg',
  }"
>
  <div
    class="nav flex-column nac-pills"
    role="tablist"
    aria-orientation="vertical"
  >
    <a
      class="nav-link"
      [ngClass]="{ 'active show': isOpen }"
      (click)="toggle()"
    >
      <div class="settings">
        <i [class]="icon"></i>
      </div>
      @if (toggleLabel) {
        <span>{{ toggleLabel }}</span>
      }
    </a>
  </div>
</div>

<!-- Backdrop -->
@if (isOpen) {
  <div class="offcanvas-backdrop" (click)="close()"></div>
}

<!-- Panel -->
<div
  class="offcanvas-panel"
  [ngClass]="{
    open: isOpen,
    'position-left': position === 'left',
    'position-right': position === 'right',
    'size-sm': size === 'sm',
    'size-md': size === 'md',
    'size-lg': size === 'lg',
  }"
>
  <div class="offcanvas-header">
    <h5 [title]="description">{{ title }}</h5>
    <i class="icofont-close icon-close" (click)="close()"></i>
  </div>
  <div class="offcanvas-body custom-scrollbar">
    <ng-content></ng-content>
  </div>
  <div class="offcanvas-footer">
    <ng-content select="[offcanvas-footer]"></ng-content>
  </div>
</div>
